import type { IntlShape } from 'react-intl'
import defaultIntl from './defaultIntl'

let currentIntl: IntlShape = defaultIntl

export function getCurrentIntl(): IntlShape {
  return currentIntl
}

export function setCurrentIntl(intl: IntlShape) {
  currentIntl = intl
}
